module.exports = __webpack_public_path__ + "static/media/arrow-down.2c43cae5.svg";